import { format } from 'date-fns';
import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Typography, Chip, Grid, Divider,
} from '@mui/material';
import API from '../../utils/Axios.utils';

const ReviewRequisitionModal = ({
    open, onClose, requisition, onUpdated,
    currentUserEmail,
    setAlert, setAlertContent, setAlertType,
}) => {
    const [loading, setLoading] = React.useState(false);

    if (!requisition) return null;

    const handleAction = async (status) => {
        setLoading(true);
        try {
            await API.put(`/api/requisitions/${requisition.id}/status`, { status });
            setAlertContent(`Requisition ${status === 'approved' ? 'approved' : 'rejected'} successfully.`);
            setAlertType('success');
            setAlert(true);
            onUpdated();
            onClose();
        } catch (err) {
            setAlertContent(err?.response?.data?.message || 'Action failed.');
            setAlertType('error');
            setAlert(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={(e, reason) => { if (reason !== 'backdropClick') onClose(e, reason); }} maxWidth="sm" fullWidth>
            <DialogTitle>Review Requisition — {requisition.requisition_id}</DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={1.5}>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Role Title</Typography>
                        <Typography variant="body2" fontWeight={600}>{requisition.role_title}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Client</Typography>
                        <Typography variant="body2">{requisition.client_name || '—'}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Department</Typography>
                        <Typography variant="body2">{requisition.department}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">No. of People</Typography>
                        <Typography variant="body2">{requisition.no_of_people}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Hiring Manager</Typography>
                        <Typography variant="body2">{requisition.hiring_manager_name || '—'}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Salary Range</Typography>
                        <Typography variant="body2">
                            {requisition.comp_band_min || 0} – {requisition.comp_band_max || 0}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Priority</Typography>
                        <br />
                        <Chip
                            label={requisition.priority}
                            color={requisition.priority === 'High' ? 'error' : 'default'}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Created By</Typography>
                        <Typography variant="body2">
                            {requisition.creator_first_name ? `${requisition.creator_first_name} ${requisition.creator_last_name} (${requisition.creator_email})` : requisition.creator_email || '—'}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary">Created Date</Typography>
                        <Typography variant="body2">
                            {requisition.created_at ? format(new Date(requisition.created_at), "dd-MM-yyyy") : '—'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}><Divider /></Grid>
                    <Grid item xs={12}>
                        <Typography variant="caption" color="text.secondary">Justification / Notes</Typography>
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                            {requisition.notes || '—'}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Cancel</Button>
                {(requisition.creator_email || '').toLowerCase() !== (currentUserEmail || '').toLowerCase() ? (
                    <>
                        <Button variant="outlined" color="error" onClick={() => handleAction('rejected')} disabled={loading}>
                            Reject
                        </Button>
                        <Button variant="contained" color="success" onClick={() => handleAction('approved')} disabled={loading}>
                            Approve
                        </Button>
                    </>
                ) : (
                    <span style={{ fontSize: 13, color: '#999', padding: '0 8px' }}>You cannot approve your own requisition.</span>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ReviewRequisitionModal;

